import SelectDestination from './DestinationSelect';
import SelectHotel from './HotelSelect';

export { SelectDestination, SelectHotel };
